import React from 'react';
import ReactDOM from 'react-dom';
import { apiService } from '../../common/apiCallService';
import Loading from '../Loading.js';
import { baseUrl } from '../../common/config.js';
import Paper from 'material-ui/Paper';
import Divider from 'material-ui/Divider';
import ReactPlayer from 'react-player';
import { Card, CardActions, CardHeader, CardMedia, CardTitle, CardText } from 'material-ui/Card';
import { domain } from '../../common/config.js';
import FlatButton from 'material-ui/FlatButton';
import MediaQuery from 'react-responsive';
import $ from 'jquery';
import moment from 'moment';
import { getColor, getImage } from '../../common/ThemeService';

class CourseContent extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      readmoreBtn: false,
      expanded: false,
      height: 'auto',
      loading: false,
      activeLesson: props.activeLesson,
      prevPath: props.prevPath ? props.prevPath : '/'
    }
    props.activelessonContent.map((obj) => {
      if (obj.type == 'text' && obj.lessons == props.activeLesson._id) {
        this.state.activeLesson = props.activeLesson
        this.forceUpdate()
        this.checkContentSize(props, obj)
      }
    })
  }

  checkContentSize = (data, lessons) => {
    if (data.activeLesson.contentName != 'Key Points' || data.activeModule.contentName === 'Win Rate') {
      let textContent = lessons.textContent.split(/<\/?(br)[^>]*>/).filter(function (content) { return content.trim() != '' && content.trim() != 'br' });
      if (textContent.length > 2) {
        this.setState({ expanded: false })
        this.setState({ readmoreBtn: true })
        this.setState({ height: '11.5em' })

      }
      else {
        this.setState({ expanded: false })
        this.setState({ readmoreBtn: false })
        this.setState({ height: 'auto' })
      }
    }
  }


  componentWillReceiveProps(nextProps) {
    nextProps.activelessonContent.map((obj) => {
      if (obj.type == 'text' && (this.state.activeLesson._id != nextProps.activeLesson._id)
        && obj.lessons == nextProps.activeLesson._id) {
        this.state.activeLesson = nextProps.activeLesson
        this.forceUpdate()
        this.checkContentSize(nextProps, obj)
      }
    })
  }


  readMoreNLess = () => {
    if (!this.state.expanded) {
      let activityTrack = []
      let track = {}
      if (localStorage.getItem('activityTrack'))
        activityTrack = JSON.parse(localStorage.getItem('activityTrack'))
      track.hit_timestamp = moment().format('YYYY-MM-DDTHH:mm:ss.SSSZ'),
        track.session_id = localStorage.getItem("token")
      track.userid = localStorage.getItem("username")
      track.deviceInfo = JSON.parse(localStorage.getItem("deviceInfo"))
      track.hit_page = 'CourseContent'
      track.hit_type = 'CourseContentClickReadMore'
      track.hit_attribute1 = this.props.activeCourse.contentName
      track.hit_attribute2 = this.props.activeModule.contentName
      track.hit_attribute3 = this.props.activeLesson.contentName
      track.hit_attribute4 = ''
      track.hit_attribute5 = ''
      activityTrack.push(track)
      localStorage.setItem('activityTrack', JSON.stringify(activityTrack))
    }
    this.setState({ height: this.state.height == 'auto' ? '11.5em' : 'auto' })
    this.setState({ expanded: !this.state.expanded })
    window.scrollTo(0, 0)
  }


  render() {
    const themeColor = getColor()
    let contentStyle = this.props.deskTop ? 'width:"74.5%"' : 'width:"100%"'
    const toggledClass = this.state.expanded ? 'expanded' : 'collapsed';
    return (
      <span className='course'>
        {this.state.loading ? <Loading /> : null}
        <div className="col-xs-12 col-sm-12 col-md-8 col-lg-8 course-content" style={{ width: this.props.deskTop ? '74.5%' : '100%' }}>
          <span className='course-content-title defcontent'>{this.props.activeLesson.contentName}
            {/* {this.props.redirectFrmReportcard

              ?
              <span style={{float:'right'}}>
                <button style ={{outline:0,border:'none'}} className='backToReportCard' onClick={()=>this.props.goBackToReportCard()}>Back to report card</button>
              </span>
             :null} */}
          </span>

          {
            this.props.activelessonContent.map((obj,index) => {

              return (
                obj.type == 'text'
                  ? this.props.activeLesson.contentName == 'Key Points' && this.props.activeModule.contentName != 'Win Rate'
                    ?
                    <div key={index} data-e2e="contentKP" dangerouslySetInnerHTML={{ __html: '<ul style="list-style-type:disc; padding-left: 2%; margin:0"><li>' + obj.textContent.replace(/<br \/><br \/>/g, "</li><br \/><li>") + '</ul>' }} style={{ paddingTop: '10px', fontFamily: 'Roboto', fontSize: '14px' }} />
                    : <div>
                      <div data-e2e="courseData" className={`content ${toggledClass}`}
                        style={{ height: this.state.height }}
                        dangerouslySetInnerHTML={{ __html: obj.textContent.replace(/\/SkillLevel>/g, `'${this.state.prevPath}'\/>`) }} />
                      {this.state.readmoreBtn
                        ? <div data-e2e="readMoreOrLess" style={{ color: themeColor, fontWeight: 'bold', marginTop: '2%', textDecoration: 'underline' }} >
                          <span data-e2e="readMoreOrLessButton" onClick={() => this.readMoreNLess()} style={{ cursor: 'pointer' }}>{this.state.expanded ? 'Read Less ' : 'Read More '}</span>
                        </div>
                        : null}
                    </div>
                  :
                  <div>
                    <span>
                      {obj.type == 'video' && obj.videoContent
                        ? obj.videoContent.map((video, index) => {
                          return (
                            <div>
                              {index >= 0
                                ? <div><br /><br /></div>
                                : null}
                              <ShowImgAndVideo title={video.title} url={video.url} checkAssets={'video'} onProgress={this.props.onProgress} onStart={this.props.onStart} />
                            </div>
                          )
                        })
                        : null}
                    </span>
                    <span>
                      {obj.type == 'chart' && obj.chartContent
                        ? obj.chartContent.map((chart, index) => {
                          return (
                            <div>
                              {index >= 0
                                ? <div><br /><br /></div>
                                : null}
                              <ShowImgAndVideo title={chart.title} url={chart.url} checkAssets={obj.type} />
                            </div>
                          )
                        })
                        : null}
                    </span>
                  </div>

              )
            })

          }
          <button data-e2e="prevButton" className={this.props.activeLesson.prevLessonStyle} style={{ outline: 0, border: 'none', float: 'left', marginBottom: '50%', marginTop: '5%' }} onClick={() => this.props.getActiveLessons(this.props.activeLesson.order - 1, true)}>
            <i className="fa fa-angle-left" style={{ fontWeight: 'bold', fontSize: '14px' }}></i>&nbsp;&nbsp;PREVIOUS CLASS
        </button>
          <button data-e2e="nextButton" className={this.props.activeLesson.nextLessonStyle} style={{ outline: 0, border: 'none', float: 'right', marginBottom: '50%', marginTop: '5%' }} onClick={() => this.props.getActiveLessons(this.props.activeLesson.order + 1, true)}>NEXT CLASS&nbsp;&nbsp;
          <i className="fa fa-angle-right" style={{ fontWeight: 'bold', fontSize: '14px' }}></i>
          </button>

        </div>
      </span>
    )
  }
}

export default CourseContent;

const ShowImgAndVideo = props => {
  const PartyPokerIcon = "//" + domain + getImage("/images/replayerIcons/", "Icon.png");
  const themeColor = getColor()
  return (
    <div>
      <Card>
        <CardHeader
          title={props.title}
          avatar={<center><img src={PartyPokerIcon} style={{ width: '25px', float: 'left', marginRight: '10px', marginTop: '-5px' }} /></center>}
          style={{ backgroundColor: '#1F1E23', borderBottom: `2px solid ${themeColor}`, verticalAlign: 'middle' }}
          titleStyle={{ fontSize: '17px', paddingRight: '0', fontWeight: 'bold', verticalAlign: 'middle' }}
        />

        {props.checkAssets == 'chart'
          ? <img src={props.url} style={{ width: '100%' }} />
          : <ReactPlayer url={props.url} style={{ backgroundColor: 'black' }} playing={false} controls={true} width='100%' onProgress={props.onProgress} onStart={props.onStart} />
        }
      </Card>
    </div>
  );
}



/** WEBPACK FOOTER **
 ** ./src/components/NewCourse/CourseContent.js
 **/